//new in Braun
import React from 'react'
import {Icon} from '@chakra-ui/react'

const RecipesIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.4043 1.15649V38.844H10.4043V1.15649H13.4043Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.7793 1.15649V13.0603C8.7823 13.8888 9.11275 14.6825 9.69863 15.2684C10.2839 15.8537 11.0767 16.1841 11.9043 16.1877C12.7319 16.1841 13.5247 15.8537 14.11 15.2684C14.6958 14.6825 15.0263 13.8888 15.0293 13.0603V1.15649H18.0293V13.0627L18.0293 13.0672C18.0244 14.689 17.3781 16.243 16.2313 17.3897C15.0845 18.5365 13.5305 19.1829 11.9088 19.1877H11.8998C10.278 19.1829 8.72408 18.5365 7.57731 17.3897C6.43054 16.243 5.78415 14.689 5.7793 13.0672L5.7793 13.0627V1.15649H8.7793Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.1887 1.26849C26.7375 1.10638 27.3239 1.1252 27.8612 1.32215C28.3985 1.51911 28.8581 1.88376 29.1722 2.36216L29.1813 2.3762C33.6936 9.42078 33.9671 16.7437 34.2132 23.3299L34.2163 23.4119C34.2163 23.4122 34.2163 23.4126 34.2163 23.4129C34.2357 23.9259 34.149 24.4372 33.9617 24.9151C33.7742 25.3933 33.4899 25.8276 33.1267 26.1908C32.7635 26.554 32.3292 26.8383 31.851 27.0258C31.3828 27.2093 30.8824 27.2963 30.38 27.2815H27.2783V38.844H24.2783V3.80774C24.282 3.23549 24.4697 2.67962 24.8138 2.22233C25.1578 1.76504 25.6399 1.43061 26.1887 1.26849ZM27.2783 24.2815H30.4049C30.4239 24.2815 30.4429 24.2818 30.462 24.2826C30.5623 24.2864 30.6624 24.2694 30.7559 24.2328C30.8494 24.1961 30.9344 24.1405 31.0054 24.0695C31.0764 23.9985 31.132 23.9135 31.1687 23.82C31.2053 23.7265 31.2223 23.6264 31.2185 23.5261L31.2184 23.525C30.9825 17.2113 30.7195 11.0034 27.2783 5.02031V24.2815Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default RecipesIcon
